import React from "react";
import { useNavigate } from "react-router-dom";
import ChatBox from "./ChatBox";

const CustomLobby: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="w-full h-screen overflow-hidden" 
      style={{ 
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}
    >
      {/* Background Video - Only for body content */}
      <div className="w-full h-full relative overflow-hidden">
        {/* Desktop Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover mt-[44px] sm:mt-[60px] hidden sm:block"
        >
          <source src="/assets/bg_main_pc.mp4" type="video/mp4" />
        </video>
        
        {/* Mobile Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover mt-[44px] block sm:hidden"
        >
          <source src="/assets/bg_main_mb.mp4" type="video/mp4" />
        </video>
        <div className="relative z-10 max-w-screen-xl mx-auto px-4 h-full">
          <div className="flex flex-row lg:flex-row justify-center items-center lg:items-end 
                lg:space-y-0 lg:space-x-32 h-full pb-4 sm:space-y-8 sm:space-x-0 
                flex-row space-y-0 space-x-4 mt-28 lg:mt-0">
            <div 
              className="bg-gradient-to-br from-green-600 to-green-800 rounded-2xl text-white relative overflow-hidden cursor-pointer transition-transform hover:scale-105 shadow-2xl
                         sm:w-[420px] sm:h-[420px]
                         w-[180px] h-[180px]"
              onClick={() => navigate("/50-congthuc")}
              style={{ 
                backgroundImage: "url('/assets/39-cong-thuc.png')", 
                backgroundSize: "cover", 
                backgroundPosition: "center"
              }}
            >
            </div>
            <div 
              className="bg-gradient-to-br from-green-600 to-green-800 rounded-2xl text-white relative overflow-hidden cursor-pointer transition-transform hover:scale-105 shadow-2xl
                         sm:w-[420px] sm:h-[420px]
                         w-[180px] h-[180px]"
              onClick={() => navigate("/tong-hop-video")}
              style={{ 
                backgroundImage: "url('/assets/tong-hop-video.png')", 
                backgroundSize: "cover", 
                backgroundPosition: "center"
              }}
            >
            </div>
          </div>
        </div>
      </div>
      
      {/* Chat Box */}
      <ChatBox />
      
      {/* Social Media Icons */}
      <div className="fixed bottom-4 left-4 flex space-x-3 z-50">
        {/* Telegram */}
        <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-600 transition-colors shadow-lg">
          <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
          </svg>
        </div>
        
        {/* Facebook */}
        <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors shadow-lg">
          <svg className="w-8 h-18 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CustomLobby;